var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":"","pb-10":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('img',{staticStyle:{"max-width":"50%"},attrs:{"src":require("@/assets/logo.png"),"width":"400"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }